var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('simple-dialog',{attrs:{"dialog":_vm.showDialog,"actions":['cancel', 'confirm'],"loading":_vm.loading,"mobile":_vm.isMobile,"title":_vm.$t('MissionOrders.unassign.title'),"text":_vm.$t('MissionOrders.unassign.confirm'),"width":500},on:{"cancel":_vm.cancel,"confirm":_vm.confirm}})
}
var staticRenderFns = []

export { render, staticRenderFns }